import { createSlice } from '@reduxjs/toolkit';
import { Nullable } from 'primereact/ts-helpers';
import { AttendeeActivity } from 'src/types/types';
import { getAttendeeActivitiesData } from 'src/redesign/features/AttendeesSidebar/views/ActivitiesSidebarView/store/actions';

export type AttendeeActivitiesState = {
  error: Nullable<string>;
  attendeeActivitiesLoading: boolean;
  attendeeActivities: Nullable<AttendeeActivity[]>;
};

const initialState: AttendeeActivitiesState = {
  attendeeActivities: null,
  error: null,
  attendeeActivitiesLoading: false,
};

export const attendeeActivitiesSlice = createSlice({
  name: 'attendeeActivities',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAttendeeActivitiesData.fulfilled, (state, action) => {
      state.attendeeActivities = action.payload.data;
      state.attendeeActivitiesLoading = false;
      state.error = null;
    });
    builder.addCase(getAttendeeActivitiesData.pending, (state) => {
      state.attendeeActivitiesLoading = true;
      state.error = null;
    });
    builder.addCase(getAttendeeActivitiesData.rejected, (state) => {
      state.error = 'fetch error';
      state.attendeeActivitiesLoading = false;
    });
  },
});
